<div class="inline-spinner-container" [class.inline-spinner-container--light]="light">
    <div class="d-flex flex-row">
        <div [style.width]="spinnerSize" [style.height]="spinnerSize" class="sp sp-circle"></div>
    </div>
</div>